import React from 'react';
import {FormControl, FormHelperText, InputBase, InputLabel, MenuItem, Select} from "@material-ui/core";
import {
    withStyles,
    makeStyles,
} from '@material-ui/core/styles';

const BootstrapInput = withStyles((theme) => ({
    root: {
        marginTop: '0 !important',
        'label + &': {
            marginTop: theme.spacing(3),
        },
        '&.Mui-error .MuiSelect-select': {
            borderColor: '#7D1C24',
            '&:hover':{
                boxShadow: '0px 0px 0px 4px #F2B8B5',
            }
        },
    },
    input: {
        color: '#2F3337',
        borderRadius: '12px',
        position: 'relative',
        backgroundColor: '#FFF',
        border: '1px solid #E3E6E8',
        fontSize: '0.9rem',
        width: '100%',
        padding: '10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        fontFamily: [
            'Poppins',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderColor: '#FFD799',
            backgroundColor: theme.palette.common.white,
            borderRadius: '12px',
        },
        '&:hover':{
            boxShadow: '0px 0px 0px 4px #FCEACE',
            borderColor: '#FFC160'
        }
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    margin: {
        width: '100%'
    },
    label: {
        color: '#758089 !important',
        fontSize: '0.9rem',
        fontWeight: 400,
        position: 'relative',
        lineHeight: '144%',
        transition: 'none',
        transform: 'none',
        marginBottom: '5px',
        '&.Mui-disabled': {
            opacity: 0.7
        }
    }
}));

export const StyledSelect: React.FC<Props> = ({id, label, onChange, value, options, showEmpty = true, error, optionsLabel, disabled = false, errorMessage = ''}) => {
    const classes = useStyles();

    return (
        <FormControl error={error} className={classes.margin} disabled={disabled}>
            <InputLabel shrink htmlFor={id} className={classes.label}>{label}</InputLabel>
            <Select
                id={id}
                name={id}
                value={value}
                onChange={onChange}
                input={<BootstrapInput />}
                renderValue={optionsLabel || (val => val)}
            >
                {showEmpty &&
                    <MenuItem value=""> &nbsp; </MenuItem>
                }

                {options && options.map((option, index) => (
                    <MenuItem key={index} value={option}>{(optionsLabel) ? optionsLabel(option) : option}</MenuItem>
                ))}
            </Select>
            {error && errorMessage &&
                <FormHelperText style={{color: '#DB575F'}}>
                    {errorMessage}
                </FormHelperText>
            }
        </FormControl>
    );
}

interface Props {
    id: string,
    label: string,
    onChange: any,
    value: any,
    options: any,
    showEmpty?: boolean,
    error?: boolean,
    errorMessage?: string,
    optionsLabel?: (option: any) => string,
    disabled?: boolean
}
